import { useState, useMemo, useCallback } from 'react'
import { message as $message } from 'antd'

import { notSetDefaultRule } from '@/services/supplier/supplierContact'

import {
    FREIGHT_CHANNEL_KEY,
    FREIGHT_UNIFIED_KEY,
    FREIGHT_SEPARATE_KEY,
    FREIGHT_MAP,
} from '@/pages/Supplier/ExpressFreight/helper'

interface useQueryNotSetDefaultRuleReturn {
    /** 商家未设置运费模板信息对象 */
    notSetDefaultRuleInfo: object
    /** 查询时的loading状态 */
    loading: boolean
    /** 查询商家未设置运费模板 */
    queryNotSetDefaultRule: () => void
    /** 显示资损提示的信息 */
    showPossibeLosses: object
}

export default function useCardInfo(): useQueryNotSetDefaultRuleReturn {
    const [notSetDefaultRuleInfo, setNotSetDefaultRuleInfo] = useState({})
    const [loading, setLoading] = useState(false)

    const queryNotSetDefaultRule = useCallback(async () => {
        setLoading(true)
        try {
            const { message, data, success } = await notSetDefaultRule()
            if (success) {
                if (data) {
                    setNotSetDefaultRuleInfo(data || {})
                }
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
        setLoading(false)
    }, [])

    const showPossibeLosses = useMemo(() => {
        let show = false
        let str = ''

        if (notSetDefaultRuleInfo?.freightModel === FREIGHT_MAP[FREIGHT_UNIFIED_KEY]) {
            show = notSetDefaultRuleInfo?.notSetDefaultRule
            str = ''
        }

        if (notSetDefaultRuleInfo?.freightModel === FREIGHT_MAP[FREIGHT_CHANNEL_KEY]) {
            str = (notSetDefaultRuleInfo?.levelNotSetRuleList || []).reduce((res, item, index) => {
                let result = res
                result += `${item}级分销商${
                    index === notSetDefaultRuleInfo?.levelNotSetRuleList?.length - 1 ? '' : '，'
                }`
                return result
            }, str)

            let notDrpStr = str ? '和部分分销商' : '部分分销商'
            str += `${notSetDefaultRuleInfo?.drpNotSetRuleList?.length ? notDrpStr : ''}`
            show =
                !!notSetDefaultRuleInfo?.levelNotSetRuleList?.length ||
                !!notSetDefaultRuleInfo?.drpNotSetRuleList?.length
        }

        if (notSetDefaultRuleInfo?.freightModel === FREIGHT_MAP[FREIGHT_SEPARATE_KEY]) {
            show = notSetDefaultRuleInfo?.warehouseNotSetRule
            str = ''
        }

        return {
            show,
            str,
        }
    }, [
        notSetDefaultRuleInfo?.drpNotSetRuleList,
        notSetDefaultRuleInfo?.freightModel,
        notSetDefaultRuleInfo?.levelNotSetRuleList,
        notSetDefaultRuleInfo?.notSetDefaultRule,
        notSetDefaultRuleInfo?.warehouseNotSetRule,
    ])

    return { notSetDefaultRuleInfo, loading, queryNotSetDefaultRule, showPossibeLosses }
}
